import { point } from '@turf/helpers';
import { ENVIRONMENT_MODE } from '../constants/app';

export const depotsDropdownMapper = (data) =>
  data
    .map(({ depotCode, depotName, depotDescription, environmentMode }) => ({
      value: depotCode,
      label: `${depotName ? `${depotName} - ` : ''}${depotCode} ${
        depotDescription ? `(${depotDescription})` : ''
      }${
        environmentMode === ENVIRONMENT_MODE.DISASTER_RECOVERY
          ? ' - ' + ENVIRONMENT_MODE.DISASTER_RECOVERY
          : ''
      } `,
    }))
    .sort((a, b) => (a.label > b.label ? 1 : -1));

export const getSelectedDepotEntity = (depots, selectedDepotCode) =>
  depots.find((depot) => depot.depotCode === selectedDepotCode);

export const selectedDepotDowngradesProps = (depots, selectedDepot) => {
  const depot = getSelectedDepotEntity(depots, selectedDepot);
  return {
    downgradeCutOff: depot?.downgradeCutOff,
    routePlannerDowngrades: depot?.routePlannerDowngrades,
  };
};

export const depotWightException = (depots, selectedDepot) => {
  const depot = getSelectedDepotEntity(depots, selectedDepot);
  return depot && depot.hideWeight;
};

export const addEnvironmentMode = (depotEnvSettings, userDepots) =>
  userDepots.map((depot) => {
    const envSettings = depotEnvSettings[depot.depotCode] || {};

    return {
      ...depot,
      ...envSettings,
    };
  });

export const getDepotByCode = (depots, depotCode) =>
  depots.find((depot) => depot.depotCode === depotCode);

export const depotsPinMapper = (depots) =>
  depots.map((depot) => point([depot.longitude, depot.latitude], { depot }));

export const allowCloseTote = (depots, depotCode) => {
  const depot = depots.find((depot) => depot.depotCode === depotCode);
  return !!depot?.allowCloseTote;
};
